@keyframes popIn {
  from {
    opacity: 0;
    transform: translateY(16px) scale(0.985);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.toast {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 32px;
  /* 노치 아이폰의 홈 인디케이터와 겹치지 않게. 지원하지 않는 엔진은 위 줄을 쓴다. */
  bottom: calc(32px + env(safe-area-inset-bottom, 0px));
  margin: 0 auto;
  width: fit-content;
  z-index: 90;
  background: var(--ink);
  color: #fcf9ee;
  border-radius: 999px;
  padding: 11px 21px;
  font-family: var(--font-label);
  font-size: 12.5px;
  letter-spacing: 0.5px;
  max-width: 86vw;
  box-sizing: border-box;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  animation: popIn 0.25s ease both;
  pointer-events: none;
}
